'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useLayoutEffect, useMemo, useRef, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H1 from 'UIComponents/elements/headings/H1';
import H3 from 'UIComponents/elements/headings/H3';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIImage from 'UIComponents/image/UIImage';
import providerSignupImageUrl from 'bender-url!marketplace-assets-base/img/provider-signup/community-creators-image.png';
import providerSignupBlobsUrl from 'bender-url!marketplace-assets-base/img/provider-signup/community-creators-blobs.png';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { Flow } from 'signup-constants/Flow';
import { SignupUrlGenerator } from 'signup-ui-url-generator/SignupUrlGenerator';

const getSignupLink = () => new SignupUrlGenerator(Flow.AssetProvider).getUrl();

const ProviderSignupBanner = () => {
  const containerRef = useRef(null);
  const leftColumnRef = useRef(null);
  const [compact, setCompact] = useState(false);
  const [containerHeight, setContainerHeight] = useState(0);
  const {
    trackBeforeUnloadInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const handleSetResponsiveStyles = useCallback(() => {
    if (containerRef.current) {
      if (containerRef.current.clientWidth >= 1100) {
        setCompact(false);
      } else {
        setCompact(true);
      }
    }

    if (leftColumnRef.current) {
      setContainerHeight(leftColumnRef.current.clientHeight);
    }
  }, [containerRef, leftColumnRef]);
  useLayoutEffect(() => {
    window.addEventListener('resize', handleSetResponsiveStyles);
    handleSetResponsiveStyles();
    return () => window.removeEventListener('resize', handleSetResponsiveStyles);
  }, [handleSetResponsiveStyles]);
  const imageStyles = useMemo(() => ({
    position: 'absolute',
    top: 0,
    right: compact ? 'auto' : 0
  }), [compact]);
  const blobStyles = useMemo(() => ({
    position: 'absolute',
    bottom: 0,
    left: compact ? -240 : -312
  }), [compact]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "row",
    ref: containerRef,
    style: {
      overflow: 'hidden'
    },
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      className: "m-right-3  p-x-10 p-top-10",
      direction: "column",
      ref: leftColumnRef,
      style: {
        width: '50%',
        paddingBottom: 100
      },
      children: [/*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.providerSignupCTA.title"
        })
      }), /*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.providerSignupCTA.subtitle"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        className: "m-top-4",
        href: getSignupLink(),
        onClick: () => {
          trackBeforeUnloadInteraction('click provider signup');
        },
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.providerSignupCTA.button"
        })
      })]
    }), /*#__PURE__*/_jsxs(UIFlex, {
      style: {
        height: containerHeight,
        position: 'relative',
        width: '50%'
      },
      children: [/*#__PURE__*/_jsx(UIImage, {
        height: containerHeight,
        responsive: false,
        src: providerSignupImageUrl,
        style: imageStyles
      }), /*#__PURE__*/_jsx(UIImage, {
        height: 124,
        responsive: false,
        src: providerSignupBlobsUrl,
        style: blobStyles
      })]
    })]
  });
};

export default ProviderSignupBanner;